(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/vikinglotto/components/play/views/betslip.js') >= 0) return;  svs.modules.push('/modules/vikinglotto/components/play/views/betslip.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.vikinglotto=_svs.vikinglotto||{};
_svs.vikinglotto.components=_svs.vikinglotto.components||{};
_svs.vikinglotto.components.play=_svs.vikinglotto.components.play||{};
_svs.vikinglotto.components.play.templates=_svs.vikinglotto.components.play.templates||{};
svs.vikinglotto.components.play.templates.betslip = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div id='jokerRegion'></div>\n<div id='drawCountRegion'></div>\n<div class='numbergames-footer-section'>\n  <div id='subscriptionInfoRegion'></div>\n  <div id='trissRegion'></div>\n  <div id='accountSelectorRegion'></div>\n</div>\n";
},"useData":true});
Handlebars.partials['svs-vikinglotto-components-play-betslip'] = svs.vikinglotto.components.play.templates.betslip;
})(svs, Handlebars);


 })(window);